import * as TABLE from 'constant/table'

export default (order, defaultOrder) => {
  switch (order) {
    case TABLE.ANTD_ACENDING:
      return TABLE.ACENDING
    case TABLE.ANTD_DESCENDING:
      return TABLE.DESCENDING
    default:
      return defaultOrder
  }
}
